"use strict";

exports.__esModule = true;
exports.default = void 0;

var _VisConditionalFormatResources = _interopRequireDefault(require("amdi18n-loader!./VisConditionalFormatResources.js"));

var _nodePolyglot = _interopRequireDefault(require("node-polyglot"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Dashboard 
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
var StringResources = /*#__PURE__*/function () {
  function StringResources() {
    /**
     * Module which provides simple access to string resources.
     */
    this.polyglot = new _nodePolyglot.default({
      phrases: _VisConditionalFormatResources.default
    });
  }
  /**
   * Get the string resource for the given key and interpolation options
   *
   * @param key						The  key of the string to return
   * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
   * @returns							The string to display
   */


  var _proto = StringResources.prototype;

  _proto.get = function get(key, interpolationOptions) {
    return this.polyglot.t(key, interpolationOptions);
  };

  return StringResources;
}();

var _default = new StringResources();

exports.default = _default;
